<template>
    <div id="paintlistforproductpage">
        <div class="productsactions">
            <ui5-label for="product-nr">
                {{ trans('pages.paintlist_for_product.enter_product_number') }}
            </ui5-label>

            <div class="field">
                <ui5-input
                    type="Text"
                    id="product-nr"
                    @input="productNr = $event.target.value"
                    @keyup.enter="addProductsToPaintlistListView"
                    :value="productNr" />
                <ui5-button @click="addProductsToPaintlistListView">
                    {{ trans('pages.paintlist_for_product.add') }}
                </ui5-button>
            </div>
        </div>

        <div id="productlistelements">
            <div
                v-for="(product, index) in products"
                :key="product.productId"
                :id="product.productId"
                class="batchelement">
                <div
                    class="batchelementaction"
                    @click="$delete(products, index)">
                    X
                </div>
                <div class="batchelementtext">{{ product.productNr }}</div>
            </div>
        </div>

        <div class="bottom-buttons">
            <ui5-button @click="calculateAndOptimizePaintlistsForProducts">
                {{ trans('pages.paintlist_for_product.calculate') }}
            </ui5-button>
            <ui5-button @click="$router.push('/paintlistform')">
                {{ trans('pages.paintlist_for_product.cancel') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import productApi from '../api/product';
import partslistApi from '../api/partslist';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            productNr: '',
            products: [],
        };
    },
    methods: {
        addProductsToPaintlistListView() {
            productApi
                .validateProductExistence(this.productNr)
                .then((response) => {
                    const product = response.data.data;
                    if (product.productId) {
                        if (
                            this.products.findIndex(
                                (x) => x.productId == product.productId
                            ) == -1
                        ) {
                            this.products.push(product);
                        } else {
                            showInfoMessage(this.trans('pages.paintlist_for_product.product_already_in_list'));
                        }
                    } else {
                        showErrorMessage(this.trans('pages.paintlist_for_product.cannot_add_product'));
                    }
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.paintlist_for_product.invalid_product_number'));
                });

            this.productNr = '';
        },
        calculateAndOptimizePaintlistsForProducts() {
            this.products.forEach((product) => {
                const productId = product.productId;
                partslistApi
                    .calculateForProduct(productId)
                    .then(() => {
                        this.$delete(
                            this.products,
                            this.products.findIndex(
                                (x) => x.productId == productId
                            )
                        );
                        if (this.products.length == 0) {
                            showInfoMessage(this.trans('pages.paintlist_for_product.calculation_successful'));
                            this.$router.push('/paintlistform');
                        }
                    })
                    .catch(() => {
                        showErrorMessage(
                            `${this.trans('pages.paintlist_for_product.calculation_error')} ${productId}`
                        );
                    });
            });
        },
    },
};
</script>
